// extracted by mini-css-extract-plugin
export var arrow = "_3o-6";
export var changeItem = "_3o-3";
export var changesHeader = "_3o-1";
export var changesList = "_3o-2";
export var container = "_3o-0";
export var pathLabel = "_3o-4";
export var value = "_3o-7";
export var valuesContainer = "_3o-5";